import { get,post } from "@/axios/http";
/**数据统计接口 */
const dataStat = data => post('/brave/gene/interpretation/findCancerPage',data);
const genData = data => post('/brave/gene/interpretation/findgenePage',data);
/**基因解读数据统计接口 */
//性别分布接口
const Gender = data => post('/brave/gene/unscramble/findSampleSex',data);
/**点突变插入缺失接口 */
const findSNVResult = data => post('/brave/gene/unscramble/findSNVResult',data);
/**拷贝数接口 */
const findCNVResult = data => post('/brave/gene/unscramble/findCNVResult',data);
/**基因重排数接口 */
const findSVResult = data => post('/brave/gene/unscramble/findSVResult',data);
/**癌肿接口 */
const findSampleCancer = data => post('/brave/gene/unscramble/findSampleCancer',data);
/**年龄分布 */
const findSampleAge = data => post('/brave/gene/unscramble/findSampleAge',data);


export{
    dataStat,
    genData,
    Gender,
    findSNVResult,
    findCNVResult,
    findSVResult,
    findSampleCancer,
    findSampleAge

}
